import { Agent, AgentPermission } from "~/services/agents";

// Editing an agent is governed by the caller's `can_edit` grant, resolved
// per-agent by the API: editors and managers hold it, a USER-level grant does
// not, and SYSTEM agents confer it on no one (read-only for everyone).
export const useCanEditAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.permissions.includes(AgentPermission.CAN_EDIT);
